<template>
  <div
    class="content_main rounded-0 pt-content position-relative"
    :class="{'bg_c9': !isThaiCharoenPlus}"
    style="margin-top: -50px"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-12 animateMe"
          data-animation="fadeInUp"
        >
          <div class="p-menu-list">
            <div 
              v-for="(item, i) in activeItems"
              :key="i"  
              class="p-menu-item"
              @click="goTo(item.routeName)"
            >
              <div
                class="hover-scale"
              >
                <div
                  class="img"
                  :class="{
                    'img-menu-cc': isChokCharoen,
                  }"
                >
                  <img
                    :src="item.link"
                  />
                </div>
              </div>
            </div>
            <div 
              v-if="wallet.is_can_spinwheel"
              class="p-menu-item"
              @click="openRoulete"
            >
              <div
                class="p-menu-link hover-scale box_shadow"
              >
                <div class="img">
                  <img
                    src="@/assets/v3/n/menu-spin.png"
                  />
                </div>
                <h5 class="mt-4">
                  ลุ้นกงล้อ
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-12 mt-2 animateMe"
          data-animation="fadeInUp"
          @click="goTo(ROUTE_INTERNAL_LOTTO)"
        >
          <div class="box-huay hover-scale">
            <div
              class="img " 
              :class="{
                'img-box-huay': isDefaultSite || isBooncharern || isSapcharern,
                'img-box-huay-cc': isChokCharoen,
              }"
            >
              <img
                v-if="isChokCharoen"
                src="@/assets/v3/n/game-cc/h-1.png"
                alt=""
              />
              <img
                v-else-if="isBooncharern"
                src="@/assets/v3/n/game-bc/h-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/game-default/h-1.png"
                alt=""
              />
            </div>
            <div class="txt">
              <h2 class="t-semibold  white--text">
                แทงหวยออนไลน์
              </h2>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe px-2"
          data-animation="fadeInUp"
          @click="selectGameType(SLOT)"
        >
          <div
            class="hover-scale box-g bg_c36"
            :class="{'scale--active': selectedGameType == SLOT}"
          >
            <div class="img">
              <img
                v-if="isChokCharoen"
                src="@/assets/v3/n/game-cc/s-1.png"
                alt=""
              />
              <img
                v-else-if="isBooncharern"
                src="@/assets/v3/n/game-bc/s-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/game-default/s-1.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                สล็อต
              </h1>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe px-2"
          data-animation="fadeInUp"
          @click="selectGameType(CASINO)"
        >
          <div
            class="hover-scale box-g bg_c35"
            :class="{'scale--active': selectedGameType == CASINO}"
          >
            <div
              class="img"
              :class="{
                'img-box-cc': isChokCharoen,
              }"
            >
              <img
                v-if="isChokCharoen"
                src="@/assets/v3/n/game-cc/c-1.png"
                alt=""
              />
              <img
                v-else-if="isBooncharern"
                src="@/assets/v3/n/game-bc/c-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/game-default/c-1.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                คาสิโน
              </h1>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe px-2"
          data-animation="fadeInUp"
          @click="selectGameType(SPORT)"
        >
          <div
            class="hover-scale box-g bg_c37"
            :class="{'scale--active': selectedGameType == SPORT}"
          >
            <div class="img">
              <img
                v-if="isChokCharoen"
                src="@/assets/v3/n/game-cc/sp-1.png"
                alt=""
              />
              <img
                v-else-if="isBooncharern"
                src="@/assets/v3/n/game-bc/sp-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/game-default/sp-1.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                กีฬา
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div>
        <ExternalGameTabExtra
          :reset-state="resetState"
          :current-type-id="selectedGameType"
        ></ExternalGameTabExtra>
      </div>
    </div>
    <dialog-roulete ref="roulete" />
  </div>
</template>
<script>
import { ROUTE_INTERNAL_LOTTO, ROUTE_CREDIT, ROUTE_LIST, ROUTE_TRASACTION, ROUTE_RESULT, ROUTE_AFFILIATE, ROUTE_CASHBACK, ROUTE_GAME_TYPE } from '@/const/route'
import dialogRoulete from '@/components/Dialog/DialogRouleteV2'
import ExternalGameTabExtra from './ExternalGameTabExtra'

// 

const CASINO = 2
const SPORT = 3
const SLOT = 4

export default {  
  components : {
    dialogRoulete,
    ExternalGameTabExtra,
  },

  data: () => ({
    selectedGameType: SLOT,
    resetState: null,
    items: [
      {
        link: require('@/assets/v3/n/default/credit.png'),
        name: 'title.credit-report',
        routeName: ROUTE_CREDIT
      },
      {
        link: require('@/assets/v3/n/default/list.png'),
        name: 'รายการโพย',
        routeName: ROUTE_LIST
      },
      {
        link: require('@/assets/v3/n/default/bank.png'),
        name: 'title.transaction-report',
        routeName: ROUTE_TRASACTION
      },
      {
        link: require('@/assets/v3/n/default/result.png'),
        name: 'ดูผลย้อนหลัง',
        routeName: ROUTE_RESULT
      },
      {
        link: require('@/assets/v3/n/default/af.png'),
        name: 'title.affiliate',
        routeName: ROUTE_AFFILIATE
      },
      {
        link: require('@/assets/v3/n/default/cashback2.png'),
        name: 'แคชแบค',
        routeName: ROUTE_CASHBACK
      },
    ],
    ccitems: [
      {
        link: require('@/assets/v3/n/cc/credit.png'),
        name: 'title.credit-report',
        routeName: ROUTE_CREDIT
      },
      {
        link: require('@/assets/v3/n/cc/list.png'),
        name: 'รายการโพย',
        routeName: ROUTE_LIST
      },
      {
        link: require('@/assets/v3/n/cc/bank.png'),
        name: 'title.transaction-report',
        routeName: ROUTE_TRASACTION
      },
      {
        link: require('@/assets/v3/n/cc/result.png'),
        name: 'ดูผลย้อนหลัง',
        routeName: ROUTE_RESULT
      },
      {
        link: require('@/assets/v3/n/cc/af.png'),
        name: 'title.affiliate',
        routeName: ROUTE_AFFILIATE
      },
      {
        link: require('@/assets/v3/n/cc/cashback.png'),
        name: 'แคชแบค',
        routeName: ROUTE_CASHBACK
      },
    ],
    bcitems: [
      {
        link: require('@/assets/v3/n/bc/credit.png'),
        name: 'title.credit-report',
        routeName: ROUTE_CREDIT
      },
      {
        link: require('@/assets/v3/n/bc/list.png'),
        name: 'รายการโพย',
        routeName: ROUTE_LIST
      },
      {
        link: require('@/assets/v3/n/bc/bank.png'),
        name: 'title.transaction-report',
        routeName: ROUTE_TRASACTION
      },
      {
        link: require('@/assets/v3/n/bc/result.png'),
        name: 'ดูผลย้อนหลัง',
        routeName: ROUTE_RESULT
      },
      {
        link: require('@/assets/v3/n/bc/af.png'),
        name: 'title.affiliate',
        routeName: ROUTE_AFFILIATE
      },
      {
        link: require('@/assets/v3/n/bc/cashback.png'),
        name: 'แคชแบค',
        routeName: ROUTE_CASHBACK
      },
    ]
  }), 
  computed : { 
    ROUTE_INTERNAL_LOTTO: () => ROUTE_INTERNAL_LOTTO,
    CASINO: () => CASINO,
    SPORT: () => SPORT,
    SLOT: () => SLOT,
    ROUTE_GAME_TYPE: () => ROUTE_GAME_TYPE,
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    activeItems () {

      if (this.isChokCharoen) {
        return this.ccitems
      }

      if (this.isBooncharern) {
        return this.bcitems
      }

      return this.items
    }
  },   

  methods: {  
     goTo (name, query = {}) { 
      this.$router.push({ name, query: query }).catch(()=>{}); 
    },
    selectGameType (game_type) { 
      this.selectedGameType = game_type
      this.resetState = Math.random().toString(36)
    },
    openRoulete () {
      this.$refs.roulete.open()
    }
  }
}
</script>
<style scoped>
.content_main {
  height: 100%;
  border-radius: 20px 20px 0 0;
}

.pt-content {
  padding-top: 60px;
}

.bg_c9 {
  background: var(--v3-sec-color-20);
}

.bg_c35 {
  background: linear-gradient(100deg, #f1e03c 0%, #ff652a 100%);
}

.bg_c36 {
  background: linear-gradient(100deg, #d21c41 0%, #c8227e 100%);
}

.bg_c37 {
  background: linear-gradient(100deg, #4cecc2 0%, #813ec2 100%);
}


.box_shadow {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.box-huay {
  width: 100%;
  display: flex;
  /* flex-wrap: wrap; */
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(180deg, var(--v3-base-color-15-main) 0%, var(--v3-base-color-5-main) 70%);
  padding: 24px 20px;
}
.box-huay .txt {
  padding: 0 0;
  font-size: 18px;
}

.t-regular {
  font-size: 20px !important;
}

.box-g {
  border-radius: 7px 28px 13px 13px;
  padding: 20px 10px 20px 10px;
  position: relative;
  height: 100%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.box-g .img {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-20%, -20%);
}
.box-g .txt {
  text-align: center;
}

.img-menu-cc {
  width: 100%;
}

.p-menu-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 10px;
  color: #0d6efd;
}
.p-menu-list .p-menu-item {
  width: calc(12.5% - 10px);
  margin: 5px;
  cursor: pointer;
}
.p-menu-list .p-menu-item .p-menu-link {
  width: 100%;
  height: 100%;
  background: var(--v3-sec-color-30);
  border-radius: 20px;
  padding: 10px 0;
  text-align: center;
}
.p-menu-list .p-menu-item .p-menu-link .img {
  width: 44px;
  margin: 0 auto;
  margin-bottom: -20px;
}

img {
  width: 100%;
}

.img-box-huay {
  width: 112px;
  margin-top: -52px;
}

.img-box-huay-cc {
  width: 112px;
  margin-top: -50px;
}

@media only screen and (max-width: 992px) {
  .p-menu-list .p-menu-item {
    width: calc(25% - 10px);
  }
}

@media only screen and (max-width: 767px) {
  .box-g {
    padding: 10px 5px 10px 5px;
    border-radius: 7px 28px 13px 13px;
  }

  .img-box-huay {
    width: 100px;
  }

  .box-g .img {
    width: 50px;
    height: 50px;
    left: auto;
    right: 0;
    transform: translate(20%, -20%);
  }
  .box-g .txt h1 {
    font-size: 18px;
  }
  .box-g .txt h3 {
    font-size: 14px;
  }
  .img-box-cc {
    margin-right: 0;
  }

  .p-menu-list .p-menu-item {
    width: calc(33.33% - 10px);
  }
}

/* .scale--active {
  transform: scale(1.05);
} */

.hover-scale {
  transition: all 0.3s;
}
.hover-scale:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.menu-list-name {
  color: var(--v3-select-main-100);
}
</style>